/**
 * Collapsible "Show filters" accordion for Views exposed filter forms.
 *
 * Wraps any .view-form > form.views-exposed-form in a collapsible panel.
 * Starts expanded if the page URL has query string params (active filters),
 * otherwise starts collapsed.
 */
(function ($, Drupal, once) {
  "use strict";

  Drupal.behaviors.exposedFilterAccordion = {
    attach: function (context) {
      var $forms = $(
        once("filter-accordion", ".view-form .views-exposed-form", context),
      );

      if (!$forms.length) {
        return;
      }

      $forms.each(function (index) {
        var $form = $(this);

        // Only bother with the accordion when the form has enough in it to be
        // worth hiding — more than two child elements in the exposed form.
        if ($form.children().length <= 2) {
          return;
        }

        var formId = $form.attr("id") || "exposed-form-" + index;
        var panelId = formId + "-filter-panel";
        var buttonId = formId + "-filter-toggle";

        // Has the user got active filters in the URL?
        var hasActiveFilters =
          window.location.search && window.location.search.length > 1;

        // Build the toggle button.
        var $button = $('<button type="button" class="filter-toggle"></button>')
          .attr("id", buttonId)
          .attr("aria-expanded", hasActiveFilters ? "true" : "false")
          .attr("aria-controls", panelId)
          .text(hasActiveFilters ? "Hide filters" : "Show filters");

        // Wrap the form in a panel we can slide, and give it the ARIA bits
        // a details/summary-style widget needs.
        $form
          .attr("id", formId)
          .wrap('<div class="filter-panel" id="' + panelId + '"></div>');

        var $panel = $form.parent(".filter-panel");
        $panel.attr("role", "region").attr("aria-labelledby", buttonId);

        // Insert the button just before the panel.
        $panel.before($button);

        // Set initial state (no animation on page load).
        if (hasActiveFilters) {
          $panel.show();
        } else {
          $panel.hide();
        }

        // Toggle handler.
        $button.on("click", function () {
          var expanded = $button.attr("aria-expanded") === "true";

          if (expanded) {
            $panel.stop(true, true).slideUp(200, function () {
              $button.attr("aria-expanded", "false").text("Show filters");
            });
          } else {
            $panel.stop(true, true).slideDown(200, function () {
              $button.attr("aria-expanded", "true").text("Hide filters");
            });
          }
        });
      });
    },
  };
})(jQuery, Drupal, once);
